import AimingOurFocusPage from "./platform/AimingOurFocusPage";
import GroundbreakingTechnologyPage from "./platform/GroundbreakingTechnologyPage";
import TheSciencePage from "./platform/TheSciencePage";

/**
 * * Platform section of the Homepage
 * @returns {React.ReactElement} Platform
 */
export default function Platform() {
  return (
    <div data-testid="platform-section" id="platform-section">
      <TheSciencePage />
      <GroundbreakingTechnologyPage />
      <AimingOurFocusPage />
    </div>
  );
}
